import { router } from 'expo-router';
import { useWindowDimensions } from 'react-native';

import { Box, Button, theme } from '@squire/ui';

import { ShopBrandingHeader } from '@/components/standby/ShopBrandingHeader';
import { routes } from '@/constants/routes';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { StandbyClosedScreenProps } from './types';

// Standby-closed view (Figma 15949-114806): branding only, no card column.
const StandbyClosedScreen = ({ shop }: StandbyClosedScreenProps) => {
  const { t } = useScreenTranslations('StandbyRegistrationScreen');
  const { width } = useWindowDimensions();
  const isDesktop = width >= theme.breakpoints.laptop;

  // replace, not push: there is nothing to return to on this dead end.
  const handleBook = () =>
    router.replace(routes.chooseProfessional({ shopRoute: shop.route }));

  const bookButton = (
    <Button
      variant="primary"
      size="large"
      onPress={handleBook}
      testID="standby-closed-book"
      accessibilityLabel={t('closed.bookButton')}
      accessibilityHint={t('closed.bookButtonHint')}
      style={isDesktop ? styles.desktopButton : undefined}
    >
      {t('closed.bookButton')}
    </Button>
  );

  return (
    <Box style={styles.root} testID="standby-closed-screen">
      {isDesktop ? (
        <Box style={styles.desktopPad}>
          <ShopBrandingHeader
            shop={shop}
            layout="desktop"
            headline={t('closed.title')}
            action={bookButton}
            variant="closed"
          />
        </Box>
      ) : (
        <Box style={styles.mobilePad}>
          <Box style={styles.mobileBranding}>
            <ShopBrandingHeader
              shop={shop}
              layout="mobile"
              headline={t('closed.title')}
              variant="closed"
            />
          </Box>
          <Box style={styles.mobileFooter}>{bookButton}</Box>
        </Box>
      )}
    </Box>
  );
};

StandbyClosedScreen.displayName = 'StandbyClosedScreen';
export { StandbyClosedScreen };
